module.exports = __webpack_public_path__ + "img/43800.a5b81e4b.jpg";